import { render } from "./TablesDb.vue?vue&type=template&id=6257e650&scoped=true"
import script from "./TablesDb.vue?vue&type=script&lang=ts"
export * from "./TablesDb.vue?vue&type=script&lang=ts"

import "./TablesDb.vue?vue&type=style&index=0&id=6257e650&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6257e650"

export default script